import { DeviceInfo } from "../data/device-info";

export const LABEL_MAX_LIMIT: number = 30;

export class DeviceLabelInfo {
    id: number;
    name: string;
    deviceList: DeviceInfo[];
    onlineCount: number;
}